import callApi from "../../utils/callApi";
import { getElectricSofa } from "../reducers/electricSofa.reducers";

export const getElectricSofaAction = (path) => {
  return async (dispatch) => {
    try {
      const res = await callApi(path, "GET", null);

      await dispatch(getElectricSofa(res.data.data));
    } catch (err) {
      console.log(err);
    }
  };
};
